import type { User } from "firebase/auth"
import type { DocumentData } from "firebase/firestore"

/**
 * Gets the username from either auth or userData
 * @param auth Firebase auth user object
 * @param userData User data from Firestore
 * @param joinName Whether to join first and last name
 * @returns Username string or array of names
 */
const getUsername = (
  auth: User | null | undefined,
  userData: DocumentData | null | undefined,
  joinName: boolean,
): string | string[] | undefined => {
  if (userData?.first_name || userData?.last_name) {
    const names = [userData?.first_name, userData?.last_name]

    if (joinName) {
      return names.join(" ")
    }

    return names
  }

  if (auth?.displayName) {
    return auth?.displayName
  }

  return undefined
}

export { getUsername }
